const currency = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" })

export const MONTH_NAMES = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
]

export const MONTH_SHORT = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"]

/** Valor oculto pelo botão "ocultar valores". */
export const HIDDEN_VALUE = "R$ ••••••"

// Espaço não separável entre o sinal e o valor: o sinal nunca quebra de linha sozinho
const NBSP = "\u00A0"

/** "R$ 1.234,56"; negativos como "− R$ 1.234,56", com o sinal de menos tipográfico. */
export function formatMoney(value: number): string {
  return value < 0 ? `−${NBSP}${currency.format(-value)}` : currency.format(value)
}

/** "+ R$ 1.234,56" ou "− R$ 1.234,56": para entradas e saídas, sempre com sinal explícito. */
export function formatSignedMoney(value: number): string {
  const abs = currency.format(Math.abs(value))
  if (value > 0) return `+${NBSP}${abs}`
  if (value < 0) return `−${NBSP}${abs}`
  return abs
}

/** "1,8%" com uma casa decimal. */
export function formatPercent(value: number, digits = 1): string {
  return `${value.toLocaleString("pt-BR", { minimumFractionDigits: digits, maximumFractionDigits: digits })}%`
}

/** Data de hoje em yyyy-mm-dd no fuso do usuário (toISOString usaria UTC e viraria o dia às 21h no Brasil). */
export function todayISO(now: Date = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`
}

/**
 * Formata uma data de calendário (lançamento, vencimento, prazo) usando só a parte yyyy-mm-dd.
 * A API devolve esses campos como meia-noite UTC; passar por new Date() recuaria um dia no Brasil.
 */
export function formatCalendarDate(iso: string | null | undefined, options?: Intl.DateTimeFormatOptions): string {
  if (!iso) return ""
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number)
  if (!y || !m || !d) return iso
  return new Date(y, m - 1, d).toLocaleDateString("pt-BR", options)
}

/** "23 set" a partir de uma data ISO (yyyy-mm-dd ou completa), sem depender do fuso. */
export function formatDayMonth(iso: string): string {
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number)
  if (!y || !m || !d) return ""
  return `${d} ${MONTH_SHORT[m - 1]}`
}

/** "1 conta", "3 contas": quantidade com o substantivo no número certo. */
export function plural(count: number, singular: string, pluralForm: string): string {
  return `${count.toLocaleString("pt-BR")} ${count === 1 ? singular : pluralForm}`
}

const brasiliaTime = new Intl.DateTimeFormat("pt-BR", { hour: "2-digit", minute: "2-digit", timeZone: "America/Sao_Paulo" })

/** Hora (HH:mm, Brasília) do instante mais antigo da lista; null quando nenhum é válido. */
export function formatOldestTime(isoList: (string | null | undefined)[]): string | null {
  const times = isoList.map((iso) => (iso ? Date.parse(iso) : NaN)).filter((t) => t > 0)
  return times.length > 0 ? brasiliaTime.format(Math.min(...times)) : null
}
